import { DeviceEnrollment } from '@/types/utilityProgramEnrollment'
import { Toggle } from '@/components'
import { useState } from 'react'
import UnenrollConfirmationModal from 'features/utility-programs/UtilityProgramEnrollmentManager/UnenrollConfirmationModal/UnenrollConfirmationModal'
import { useViewModel } from './useViewModel'
import { UtilityProgramViewConfig } from '@/types/utilityProgram'
import { EnrollmentRoot } from '@/types/programs-new/programs-new'
import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'

const isDeviceEnrolled = (enrollment: EnrollmentRoot) =>
  !enrollment.unenrolled_at

type Props = {
  enrollment: EnrollmentRoot | null
  viewConfig: UtilityProgramViewConfig
  onChange?: (enrollment: EnrollmentRoot | null) => void
  onSuccess: (enrollment: DeviceEnrollment) => void
  onError: (error: string) => void
  utilityProgramId: number
  deviceId: string | number
  deviceType: DeviceType
}

export function ProgramStatusToggle(props: Props) {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const closeConfirmation = () => setShowConfirmation(false)
  const showConfirmationModal = () => {
    setShowConfirmation(true)
  }

  const { isUpdating, updateEnrollment, onToggle } = useViewModel({
    ...props,
    showConfirmationModal,
  })

  const isEnrolled = props.enrollment
    ? isDeviceEnrolled(props.enrollment)
    : false

  const onConfirm = () => {
    closeConfirmation()
    updateEnrollment()
  }

  return (
    <>
      <Toggle
        id="utility-enrollment-toggle"
        checked={isEnrolled}
        onChange={onToggle}
        disabled={isUpdating}
      />
      <UnenrollConfirmationModal
        open={showConfirmation}
        onClose={closeConfirmation}
        onContinue={onConfirm}
        viewConfig={props.viewConfig}
      />
    </>
  )
}
